import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';


export const EventRowGolfSelectionsWrapper = withConfig(theme => styled('section', { label: 'EventRowGolfSelectionsWrapper' })`
    padding: ${theme.star.padding.medium};
    border-bottom: 1px solid ${theme.star.unified.eventRow.borderColor};

    [class$='SelectionList'] {
        border: none;
        gap: ${theme.star.gap.small};
    }

    [class$='SelectionsGroup'] {
        gap: ${theme.star.gap.small};

        [class$='SelectionsGroupLiItem'] {
            border: none;
            padding: 0;
        }
    }

    [class$='MoreLessGroup'] {
        border: none;
        margin-bottom: -8px;
        margin-top: 8px;
    }
`);